import { createApp } from 'vue'

// Select the App you want to run on main, each individual are on /appName/App.vue
import NewsletterBlock from './NewsletterBlock.vue'




const klaviyoNewsletter = document.getElementById('klaviyo-newsletter')
const app = createApp(NewsletterBlock);


if (klaviyoNewsletter) {
  // if the user is using an apple mobile device, we need to mount the search bar immediately
  // for some reason, those devices requires two presses to open the modal, and not one like other browsers
//   if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
//     app.mount("#klaviyo-newsletter");
//   } else {
//     klaviyoNewsletter.addEventListener('mouseover', (e) => {
//       app.mount("#klaviyo-newsletter");
//     })
//   }
    const newsletterObserver = new IntersectionObserver(async (entries) => {
        if (entries[0].isIntersecting) {
            app.mount("#klaviyo-newsletter");
            newsletterObserver.disconnect();
        }
    });
    newsletterObserver.observe(klaviyoNewsletter);
}
